import React from "react";
import { Link } from "react-router-dom";
import { Button, Typography } from "antd";
import useCan from "../../../Hooks/useCan";
import { HomeGrantsModel } from "../../../Models/HomeGrantsModel";
import { RecommendationLinesColumns } from "../../../Static/RecommendationLinesColumns";
import TableDefault from "../../Shared/TableDefault";
import "./styles.css";

const { Title } = Typography;
interface IRecommendationLinesComponentProps {
    companyId: string;
    grantsHome: HomeGrantsModel[];
}

export default function RecommendationLinesComponent({
    companyId,
    grantsHome,
}: IRecommendationLinesComponentProps) {
    const canView = useCan({
        rolesCan: ["HumanResources", "Dossie", "Financial", "FINNSeguros - Extern"],
    });

    return (
        <div className="recommendation-lines-card">
            <div className="card-header">
                <Title level={5} className="card-title">
                    Linhas Recomendadas
                </Title>
            </div>
            <div className="card-body">
                <TableDefault
                    firstColumnIsLink={true}
                    columns={RecommendationLinesColumns}
                    rows={grantsHome}
                    hasHeader={true}
                    hasPagination={false}
                    linkToFirstColumn={"/grantsSearcher/grants/"}
                />
                {!canView && (
                    <div className="button-container">
                        <Button type="primary">
                            <Link to={`/grantsSearcher/grants`}>Veja Mais...</Link>
                        </Button>
                    </div>
                )}
            </div>
        </div>
    );
}
